export default {
  name: "TemOffWeb",
  data() {
    return {};
  }
};